import React from "react";
import "./index.scss";
import { Grid } from "antd";
import Marquee from "react-marquee-slider";
import { trustedEmployers } from "../../../../Utils/staticData";

const TrustedBy = () => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = screens.xs;
  return (
    <div className="trusted-container">
      <p className="trusted-caption">
        Trusted by individual contributors, executives, venture backed companies,
        and leading executive search experts
      </p>
      <Marquee velocity={isMobile ? 10 : 30}>
        {trustedEmployers.map((logo, index) => (
          <img
            src={logo}
            alt="customer-logo"
            height="50px"
            className="trusted-by-logo"
            key={logo || index}
          />
        ))}
      </Marquee>

    </div>
  );
};

export default TrustedBy;
